(function (angular) {
	'use strict';

	angular.module('eventsModule', [
		'BaseConfig',
		'revealModule'
	]);
})(window.angular);